import ContactService from '../../../../../services/contact_service';

const Version = ({ userId, logout, message }) => {
  
  const increaseUpdateNumber = async (userUp) => {
    try {
      const update = await ContactService.update(userId, {
        UpdateNumber: Number(userUp?.UpdateNumber) + 1,
      });
      if (logout(update)) return;
    } catch (e) {
      message(e?.message || e, "error");
    }
  };

  return {
    increaseUpdateNumber,
  };
};

export default Version;
